import { createListenerMiddleware } from '@reduxjs/toolkit';
import { setActiveProduct } from '../Reducers/ProductPage/Actions/setActiveProduct.action';
import store from '../store';

export const productSelectorListener = createListenerMiddleware();

productSelectorListener.startListening({
  actionCreator: setActiveProduct.fulfilled,
  effect: (action) => {
    if (action.payload.isPopState) return;

    const productUrl = action.payload?.response?.productItem?.url;
    if (!productUrl) return;
    window.history.pushState(
      {
        name: 'productSelector',
        productId: action.payload?.response?.productItem.id,
      },
      '',
      productUrl
    );
  },
});

if (global.window) {
  window.addEventListener('popstate', (e) => {
    if (e.state?.name == 'productSelector') {
      store.dispatch(
        setActiveProduct({ id: e.state.productId, isPopState: true })
      );
    }
  });
}
